import React from "react";
import PropTypes from "prop-types";

import "./styles/components/SectionHeader.css";

const SectionHeader = props => {
  return (
    <div
      className={`u-align-${props.headerAlign} u-margin-bottom-${props.marginBottom}`}
    >
      <h2
        className="heading-secondary"
        style={{
          background: `linear-gradient(to right bottom, ${props.colourPrimary}, ${props.colourSecondary})`,
          WebkitBackgroundClip: "text"
        }}
      >
        {props.title}
      </h2>
    </div>
  );
};

SectionHeader.defaultProps = {
  marginBottom: "big",
  headerAlign: "center",
  colourPrimary: "rgba(0, 47, 75, 0.6)",
  colourSecondary: "rgba(220, 37, 211, 0.6)",
  title: "Section Heading"
};

SectionHeader.propTypes = {
  marginBottom: PropTypes.string.isRequired,
  headerAlign: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/layout/SectionHeader.js